import { _File } from "../files/types.js";
import { WebPartsPersonalizationScope, LimitedWebPartManager } from "./types.js";
_File.prototype.getLimitedWebPartManager = function (scope) {
    if (scope === void 0) { scope = WebPartsPersonalizationScope.Shared; }
    return LimitedWebPartManager(this, "getLimitedWebPartManager(scope=" + scope + ")");
};
//# sourceMappingURL=file.js.map